import { render, staticRenderFns } from "./workinghours.vue?vue&type=template&id=50289e51&scoped=true"
import script from "./workinghours.vue?vue&type=script&lang=js"
export * from "./workinghours.vue?vue&type=script&lang=js"
import style0 from "./workinghours.vue?vue&type=style&index=0&id=50289e51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50289e51",
  null
  
)

export default component.exports